module.exports = __webpack_public_path__ + "static/media/hero.89e0530c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero.jpg
// module id = 196
// module chunks = 51